export class Credit{
    constructor(public Amount: number, public date: Date){}
}